import React from "react";
import { Link } from "react-router-dom";
import { useLenis } from "lenis/react";
import { useLang } from "@/LanguageContext";
import { COMPANY } from "@/content";

export default function Footer() {
  const { t } = useLang();
  const lenis = useLenis();
  const year = new Date().getFullYear();

  const top = () => (lenis ? lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" }));

  return (
    <footer data-testid="site-footer" className="relative bg-navy border-t border-white/10 pt-20 pb-10 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 pb-16">
          <div className="lg:col-span-5">
            <button onClick={top} className="flex flex-col items-start leading-none">
              <span className="font-serif text-4xl text-white">Magis</span>
              <span className="text-xs uppercase tracking-[0.42em] text-gold mt-1">Belgium</span>
            </button>
            <p className="text-xs uppercase tracking-[0.24em] text-gold/70 mt-8">{COMPANY.group}</p>
            <a href={`https://${COMPANY.website}`} target="_blank" rel="noopener noreferrer" className="inline-block text-white/60 mt-3 hover:text-gold transition-colors duration-300">{COMPANY.website}</a>
          </div>
          <div className="lg:col-span-4 lg:col-start-6">
            <div className="text-xs uppercase tracking-[0.3em] text-white/40">{t.footer.addressLabel}</div>
            <p className="text-white/75 mt-4 leading-relaxed">{COMPANY.address}</p>
          </div>
          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] text-white/40">{t.footer.contactLabel}</div>
            <a href={`mailto:${COMPANY.email}`} className="block text-sm text-white/75 mt-4 hover:text-gold transition-colors duration-300 whitespace-nowrap">{COMPANY.email}</a>
            <p className="text-white/75 mt-2">{t.footer.vatLabel} {COMPANY.vat}</p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-8">
          <span className="text-xs text-white/40">© {year} {COMPANY.legal}. {t.footer.rights}</span>
          <div className="flex items-center gap-6">
            <Link to="/privacy" data-testid="footer-privacy" className="text-xs text-white/50 hover:text-gold transition-colors duration-300">{t.footer.privacy}</Link>
            <Link to="/legal" data-testid="footer-legal" className="text-xs text-white/50 hover:text-gold transition-colors duration-300">{t.footer.legal}</Link>
            <span className="text-xs text-white/40">Brussels · Belgium</span>
          </div>
        </div>
      </div>
      <div aria-hidden className="pointer-events-none select-none text-center -mb-8 mt-8">
        <span className="font-serif text-[18vw] leading-none text-white/[0.03]">MAGIS</span>
      </div>
    </footer>
  );
}
